<template>
  <header class="header">
    <div class="container">
          <nav>
        <div class="menu">
          <router-link to="/">Home</router-link>
          <router-link to="/focus-matriz">Focus Matriz</router-link>
          <router-link to="/focus-filial">Focus Filial</router-link>
          <router-link to="/galileos">Galileos</router-link>
          <router-link to="/novera">Novera Cosméticos</router-link>
        </div>
      </nav>
    </div>

  </header>
</template>

<script>

export default {
  name: "TheHeader",
};
</script>
